import { render } from "./Modal.vue?vue&type=template&id=3688a55d&bindings={\"closeModal\":\"options\"}"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script